<template>
  <section class="artshare" :class="{opened: opened}"> 
    <div class="modal-background"></div>
    <div class="modal">
      <button class="close" @click="close">
        X
      </button>
      <div class="social">
        <a class="twitter" :href="`https://twitter.com/intent/tweet?url=${escapedLink}&hashtags=cityphography,art`" @click="twitterLink" target="_blank"></a>
        <a class="facebook" :href="`https://www.facebook.com/sharer/sharer.php?u=${escapedLink}&hashtag=%23cityphography`" @click="facebookLink" target="_blank"></a>
        <a class="pinterest" :href="`https://pinterest.com/pin/create/link/?url=${escapedLink}&media=${mediaLink}&description=${description}`" @click="pinterestLink" target="_blank"></a>
        <a class="jpgdownload" @click="downloadImage"></a>
      </div>
      <div class="spinner" v-if="loading"></div>
      <canvas id="canvas" hidden width="950" height="300" />
      <div class="link">
        <input v-model="shareableLink" readonly @click="selectLink" ref="input" />
        <button @click="copyLink"><span>COPY</span></button>
      </div>
    </div>
    <Snackbar ref="snackbar" />    
  </section>
</template>

<script>
import Snackbar from '@/components/Snackbar.vue';
import { saveAs } from 'file-saver';
import axios from 'axios';

export default {
  name: 'ArtsharePopup',
  data: function (){
    return{
      opened: false,
      loading: false,
      blob: undefined,
      previousReferenceId: undefined
    }
  },
  props: ['referenceId'],
  computed: {
    description(){
      return "typography%20infused%20street%20photography"
      // return encodeURIComponent("This is a very interesting letter made by my for testing and it is extremely useful I suppose and nice long text.")
    },
    mediaLink(){            
      return encodeURIComponent(this.blob ? `${process.env.VUE_APP_BLOB_ROOT}generated/${this.referenceId}.jpg` : `${process.env.VUE_APP_THUMBNAILS_BLOB_ROOT}p7pinterest.jpg`)
    },
    escapedLink(){
      //return this.shareableLink.replace('#','%23')
      return encodeURIComponent(this.shareableLink)
    },
    shareableLink: function(){ 
      return window.location.origin + "/share/" + this.referenceId;        
    },
  },  
  methods: {
    // poptest(){
    //   window.open(`https://www.facebook.com/sharer/sharer.php?u=${this.shareableLink.replace('#','%23')}`, 'fb', 'width=800, height=600')
    //   return false
    // },
    open: async function(){
      this.opened = true;   
      if(this.referenceId != this.previousReferenceId)
        await this.generateImage() 
      this.appInsights.trackEvent({ name: "ArtsharePopup.Open", properties: {link: this.shareableLink}})      
    },
    close: function(){
      this.opened = false;
      this.appInsights.trackEvent({name: "ArtsharePopup.Close"});
      this.previousReferenceId = this.referenceId
    },
    selectLink: function(){
      this.$refs.input.focus();
      this.$refs.input.select();
    },
    copyLink: function(){
      this.selectLink();
      document.execCommand("copy");
      this.$refs.snackbar.show('Link copied to clipboard')
      this.appInsights.trackEvent({name: "ArtsharePopup.CopyLink"});
    },
    twitterLink: function(){
      this.appInsights.trackEvent({name: "ArtsharePopup.TwitterLink"});
    },
    facebookLink: function(){
      this.appInsights.trackEvent({name: "ArtsharePopup.FacebookLink"});
    },
    pinterestLink: function(){
      this.appInsights.trackEvent({name: "ArtsharePopup.PinterestLink"});
    },    
    async generateImage(){     
      if(this.loading)
        return;

      try {
        this.loading = true
        
        const shadowed = true
        const letterBorder = 1
        const letterHorizontalMargin = 2
        const letterWidth = 90
        const letterHeight = 135
        const letterTotalWidth = letterBorder * 2 + letterHorizontalMargin * 2 + letterWidth

        const mats = {
          GREY:  {id: "mat-grey", matColor: "#989898", borderColor: "#d3d3d3"},
          WHITE: {id: "mat-white", matColor: "#f0f0f0", borderColor: "#ffffff"},
          BLACK: {id: "mat-black", matColor: "#202020", borderColor: "#808080"}
        }

        let hash = atob(this.referenceId)
        let frameModel = {}
        // frameStyle.frame = frames[this.referenceId.split('_')[1]]
        frameModel.type = "modern"
        // frameStyle.color = this.referenceId.split('_')[2]      
        frameModel.color = "black"
        frameModel.mat = mats[hash.split('_')[3].substring(4).toUpperCase()]
        frameModel.letters = hash.toLowerCase().split('_')[0].split('|');

        const frameConfig = { // TODO switch based on frame type once more frames come         
          border: 18,
          padding: 36,
          height: 245
        }    

        const frameWidth = frameConfig.border * 2 + frameConfig.padding * 2 + letterTotalWidth * frameModel.letters.length;      
        const boxShadow = shadowed ? 40 : 0;
        const imagePadding = 35

        const totalWidth = frameWidth + (boxShadow + imagePadding) * 2;
        const totalHeight = frameConfig.height + (boxShadow + imagePadding) * 2;

        let canvas = document.getElementById("canvas");
        canvas.width = totalWidth
        canvas.height = totalHeight - 20 // custom edit, looks nicer a bit if the logo on top has more vertical space than on the bottom where the website address is written
        let ctx = canvas.getContext("2d");

        ctx.fillStyle = "white";
        ctx.fillRect(0, 0, canvas.width, canvas.height);

        const blobRoot = "https://blob.cityphography.com";

        const frameBorderLeft = new Image()
        frameBorderLeft.crossOrigin = "Anonymous"      
        frameBorderLeft.src = `${blobRoot}/emails/images/${frameModel.type}-${frameModel.color}-frame-left${(shadowed ? "-shadowed" : "")}.png`;
              
        const frameBorderRight = new Image()
        frameBorderRight.crossOrigin = "anonymous"
        frameBorderRight.src = `${blobRoot}/emails/images/${frameModel.type}-${frameModel.color}-frame-right${(shadowed ? "-shadowed" : "")}.png`;
        
        const frameBorderMiddle_100 = new Image()
        frameBorderMiddle_100.crossOrigin = "anonymous"
        frameBorderMiddle_100.src = `${blobRoot}/emails/images/${frameModel.type}-${frameModel.color}-frame-middle${(shadowed ? "-shadowed" : "")}-100.png`;

        const frameBorderMiddle_10 = new Image()
        frameBorderMiddle_10.crossOrigin = "anonymous"
        frameBorderMiddle_10.src = `${blobRoot}/emails/images/${frameModel.type}-${frameModel.color}-frame-middle${(shadowed ? "-shadowed" : "")}-10.png`;

        const frameBorderMiddle_1 = new Image()
        frameBorderMiddle_1.crossOrigin = "anonymous"
        frameBorderMiddle_1.src = `${blobRoot}/emails/images/${frameModel.type}-${frameModel.color}-frame-middle${(shadowed ? "-shadowed" : "")}-1.png`;

        const logo = new Image()
        logo.crossOrigin = "anonymous"
        logo.src = `${blobRoot}/emails/images/logo-bold-downsized.png`;


        let thumbnails = frameModel.letters.map(letterCode => {
          let img = new Image()
          img.crossOrigin = "anonymous"
          img.src = `${blobRoot}/thumbnails/${letterCode}.jpg`
          return img
        })

        await Promise.all(
          [
            frameBorderLeft.decode(),
            frameBorderRight.decode(),
            frameBorderMiddle_100.decode(),
            frameBorderMiddle_10.decode(),
            frameBorderMiddle_1.decode(),
            logo.decode()
          ].concat(thumbnails.map(t => t.decode()))
        );

        ctx.drawImage(logo, Math.round(totalWidth/2 - 84), 26, 170, 28) 

        ctx.font = "12px Courier";
        ctx.fillStyle = "#adadad"
        ctx.fillText("© cityphography.com", Math.round(totalWidth/2 - 69), 350);

        ctx.drawImage(frameBorderLeft, imagePadding, imagePadding, frameConfig.border + frameConfig.padding + boxShadow, totalHeight - (imagePadding*2))
        // ctx.fillStyle = 'orange';
        // ctx.fillRect(0, 0, frameConfig.border + frameConfig.padding + boxShadow, 5);

        ctx.drawImage(frameBorderRight, totalWidth - frameConfig.border - frameConfig.padding - boxShadow - imagePadding, imagePadding, frameConfig.border + frameConfig.padding + boxShadow, totalHeight - (imagePadding * 2))

        if (shadowed) {
          let areaLeft = (frameWidth - frameConfig.border * 2 - frameConfig.padding * 2);
          let areaCovered = 0;

          for (let i = 0; i < Math.floor(areaLeft / 100); i++) {          
            ctx.drawImage(frameBorderMiddle_100, frameConfig.border + frameConfig.padding + boxShadow + imagePadding + areaCovered, imagePadding, 100, totalHeight - (imagePadding*2))  
            // ctx.fillStyle = 'red';    
            // ctx.fillRect(frameConfig.border + frameConfig.padding + boxShadow + areaCovered, 0, 100, 5)      
            areaCovered += 100
          }

          areaLeft -= areaCovered;

          for (let i = 0; i < Math.floor(areaLeft / 10); i++) {
            ctx.drawImage(frameBorderMiddle_10, frameConfig.border + frameConfig.padding + boxShadow + imagePadding + areaCovered, imagePadding, 10, totalHeight - (imagePadding*2))
            // ctx.fillStyle = 'green'; 
            // ctx.fillRect(frameConfig.border + frameConfig.padding + boxShadow + areaCovered, 0, 10, 5)
            areaCovered += 10;
          }

          areaLeft = (frameWidth - frameConfig.border * 2 - frameConfig.padding * 2) - areaCovered;

          for (let i = 0; i < areaLeft; i++) {
            ctx.drawImage(frameBorderMiddle_1, frameConfig.border + frameConfig.padding + boxShadow + imagePadding + areaCovered, imagePadding, 1, totalHeight - (imagePadding*2))
            // ctx.fillStyle = 'aqua'; 
            // ctx.fillRect(frameConfig.border + frameConfig.padding + boxShadow + areaCovered, 0, 1, 5)
            areaCovered += 1;
          }
        }
        else
        {
            // empty
        }

        ctx.fillStyle = frameModel.mat.matColor; 
        ctx.fillRect(
          imagePadding + boxShadow + frameConfig.border, 
          imagePadding + boxShadow + frameConfig.border, 
          frameWidth - frameConfig.border * 2, 
          frameConfig.height - frameConfig.border * 2
        )

        for (let i = 0; i < thumbnails.length; i++)
        {
          ctx.fillStyle = frameModel.mat.borderColor; 
          ctx.fillRect(
            imagePadding + boxShadow + frameConfig.border + frameConfig.padding + letterHorizontalMargin + letterTotalWidth * i, 
            imagePadding + boxShadow + frameConfig.border + frameConfig.padding, 
            letterWidth + letterBorder * 2, 
            letterHeight + letterBorder * 2
          )
          
          ctx.drawImage(
            thumbnails[i], 
            imagePadding + boxShadow + frameConfig.border + frameConfig.padding + letterHorizontalMargin + letterBorder + letterTotalWidth * i, 
            imagePadding + boxShadow + frameConfig.border + frameConfig.padding + letterBorder, 
            letterWidth, 
            letterHeight)          
        }

        // JUST FOR TESTING!!!!!!!!!!!!!!!!!!!!        
        // await new Promise(resolve => setTimeout(resolve, 3000)); // 3 sec

        //let w = frameModel.letters.reduce((word, code) => word + code.substring(0,1), '') // ha akarom a szót csak, amúgy a hash a fullos
        canvas.toBlob(async blob => {
            //console.log(blob)
            this.blob = blob
            await axios.post(process.env.VUE_APP_SHARE_WORKER_URL + this.referenceId, blob)
            //axios.post( 'https://graph.facebook.com', { id: this.shareableLink, scrape: true }) lol this needs authentication
            // await axios({ url: 'http://127.0.0.1:8787/share/something', 
            // data: blob, 
            // method: "POST", 
            // mode: 'no-cors' })
        }, 'image/jpeg');
      }
      catch(error){
        console.error(error)
        this.$refs.snackbar.show('Something went wrong while generating the image : (')
        this.appInsights.trackException({exception: new Error(error)})
      }
      finally{
        this.loading = false
      }
    },
    async downloadImage(){
      saveAs(this.blob, `cityphography_${this.referenceId}.jpg`)
      this.appInsights.trackEvent({name: "ArtsharePopup.DownloadImage"})
    }
  },
  components: {
    Snackbar
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.artshare{  
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 200;
  background-color: rgba($color: #fff, $alpha: 0.4);
  visibility: hidden;  
  opacity: 0;  
  transition: opacity 0.3s ease, visibility 0.3s ease;

  &.opened{
    visibility: visible;  
    // width: 100%;
    // height: 100%;  
    // top: 0;
    // bottom: 0;
    // right: 0;
    // left: 0;
    // z-index: 200;
    opacity: 1;
    transition: opacity 0.3s ease;//, visibility 0.2s ease;

    .modal{
      opacity: 1;
    }
  }

  .modal-background{
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    z-index: 101;
    background-color: rgba($color: #000000, $alpha: 0.5);
  }

  .modal{
    opacity: 0;
    max-width: 480px;
    max-height: 310px;
    background-color: white;        
    z-index: 200;
    margin: 0 auto;
    position: relative;
    top: 50%;
    margin-top: -155px;
    box-shadow: 0px 0px 200px 20px rgba(0,0,0,0.5);

    .close{
      border: none;
      background: none;
      cursor: pointer;
      position: absolute;
      right: 20px;
      top: 15px;      
      z-index: 300;  
      box-sizing: border-box;
      color: transparent;
      font-size: 20px;
      outline: none;
      overflow: hidden;
      text-transform: uppercase;
      transition: all 0.2s ease-in;
      width: 20px;
      height: 20px;
      padding: 2px 0 0;
      font-family: 'Courier New', Courier, monospace;
      user-select: none;

      &:before, 
      &:after {
        background-color: rgba($color: #000000, $alpha: 0.2);
        content: '';
        display: block;
        height: 1px;
        left: 0;
        position: absolute;
        transform-origin: center left;
        transition: all 0.2s ease-in;
        width: 28.28428px;
        z-index: -1;
      }

      &:before {
        top: 0;
        transform: rotate(45deg);
      }

      &:after {
        bottom: 0;
        transform: rotate(-45deg);
      }

      &:hover {
        color: black;
        width: 30px;
        height: 30px;
        right: 15px;
        top: 10px;   
      }

      &:hover::before,
      &:hover::after {
        height: 30px;
        width: 30px;
        transform: rotate(0deg);
        background-color: #f9f9f9;;
      }
    }  

    .spinner{
      position: absolute;
      background: url(../assets/images/294.svg) center no-repeat;
      background-size: cover;
      width: 100%;
      height: 1px;
      //left: 25%;
      // margin-left: -15px;
      top: 179px;
      opacity: 0.5;
    }

    .social{
      height: 179px;
      background-color: var(--color-share-icons-bg);
      border-bottom: 1px dashed var(--color-share-divider);
      display: flex;
      justify-content: space-evenly;

      a {
        height: 50px;
        width: 50px;    
        display: inline-block;   
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
        cursor: pointer; 
        opacity: 0.75;
        margin-top: 70px;

        &:hover{
          opacity: 1;
        }
      }

      .twitter{
        background-image: var(--asset-share-twitter-icon);
        background-size: 80%;     
        &:hover{
          background-size: 90%;
        }  
      }
      .facebook{
        background-image: var(--asset-share-facebook-icon);  
        background-size: 150%;  
        &:hover{
          background-size: 170%;
        } 
      }
      .pinterest{
        background-image: var(--asset-share-pinterest-icon);   
        background-size: 90%;   
        &:hover{
          background-size: 100%;
        } 
      }
      .jpgdownload{
        background-image: var(--asset-share-jpg-icon);  
        background-size: 78%;           
        margin-top: 66px;
        height: 55px; // bakground not square, need more space to fit
        &:hover{
          background-size: 85%;
        } 
      }
    }

    .link{
      padding: 40px 20px;
      display: flex;
      background-color: var(--color-share-link-bg);

      input{
        border: none;
        border-bottom: 1px solid var(--color-share-input-border);
        background-color: var(--color-share-link-bg);
        height: 44px;
        line-height: 39px;
        outline: none;
        flex: 1;
        padding: 0 5px;
        margin-right: 20px;
        font-family: 'Courier New', Courier, monospace;
        font-size: 14px;
        color: var(--color-share-input-text)
      }

      button{
        flex: 0 0 70px;
        height: 45px;
        line-height: 45px;
        width: 70px;
        font-size: 15px;
        background-color: #242424;
        background-color: rgba($color: #000000, $alpha: 0.85);
        color: white;
        text-transform: uppercase;
        border: none;
        outline: none;
        cursor: pointer;
        text-align: center;
        transition: all 0.1s;
        font-family: 'Courier New', Courier, monospace;
        user-select: none;

        // span{
        //   display: block;
        //   transform: scale(0.95);
        // }

        &:hover{              
          background-color:black; 
          span{
            display: block;
            transform: scale(0.95);
            //transform: scale(1);
            transition: all 0.1s;
          }
        }
      }
    }
  }

}

.dark .artshare .modal .close {

  //color: #fff;

  &:before, &:after {
    background-color: rgba($color: #ffffff, $alpha: 0.25);
  }

  &:hover {
    color: white;
  }

  &:hover::before,
  &:hover::after {
    background-color: #f9f9f9;
    background-color: var(--color-share-icons-bg);
  }
}
</style>
